module.exports = __webpack_public_path__ + "img/firma-2-2-pazysalvo-1.0e12dc59.jpg";